<template>
  <page>
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="cms-nav-bar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      opacity-style
      :opacity="opacity"
      :title="'同行热销榜'"
      @click-left="goBack"
    />
    <div
      ref="expandHeader"
      class="hot-sale-header"
      :style="{
        backgroundImage: 'url(' + headImg + ')'
      }"
    >
      <p class="header-content">
        <img src="@/images/hotSaleList/address.png" class="position-icon" />
        <span class="city-name">{{ cityName }}</span>
        <span v-if="labelName" class="label-name">{{ labelName }}</span>
      </p>
    </div>
    <div
      class="expand-tab"
      :style="{ top: isMiniProgram ? '0' : 44 + statusBarHeight + 'px' }"
    >
      <van-tabs
        v-if="biList.length"
        v-model="biId"
        line-width="20px"
        sticky
        @change="handleChangeTab"
      >
        <van-tab
          v-for="item in biList"
          :key="item.biId"
          :title="item.name"
          :name="item.biId"
        >
        </van-tab>
      </van-tabs>
    </div>
    <div class="expand-content">
      <div v-if="!isLoading && isEmpty" class="expand-content-empty">
        <img src="../../images/hotSaleList/no_goods.png" alt="" />
        <div>暂无商品</div>
      </div>
      <van-loading v-if="isLoading" class="loading" />
      <div v-if="!isLoading && !isEmpty">
        <SoleGoods
          v-for="(item, index) in goodsList"
          :key="index"
          v-expose-track="{
            hotSaleList: {
              mapId: 'hotSaleList',
              data: {
                ...getTracerParams(item, index)
              }
            }
          }"
          :ssu="item.ssuList[0]"
          :sku="item"
          :sort-index="index + 1"
          :good-width="72"
          :report-name="'hotSaleList'"
          @beforeGoDetail="onGotoDetailTrack(item, index)"
          @beforeAddGoods="onAddGoodsTrack(item, index)"
          @beforeGotoShop="onGotoShopTrack(item, index)"
        >
        </SoleGoods>
      </div>
    </div>
    <cart-float-window @beforeGoCart="onClickFloatCartTrack" />
  </page>
</template>
<script>
import SoleGoods from '../similarGoods/components/sole-good'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { miniProgramEnv } from '@/defines/environment'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import { API } from '@/api'
import { resolveUrlParams } from '@/utils/utils'
import headBgImg from '@/images/hotSaleList/head_bg.png'
export default {
  components: { SoleGoods, CartFloatWindow },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.biId = Number(vm.$route.query.biId || 0)
      vm.getHotSaleRankInfo(vm.biId)
      vm.handleScroll()
      vm.handlePageTrack()
    })
  },
  data() {
    return {
      biId: 0,
      opacity: 0,
      goodsList: [],
      // 热销和低价lowerPrice
      dataType: 'hotSell',
      isLoading: false,
      isEmpty: false,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      biList: [],
      cityName: '',
      labelName: '',
      headImg: ''
    }
  },
  // 监控路由状态的改变获取参数重载页面
  watch: {
    $route(to, from) {
      location.reload()
    }
  },
  methods: {
    getTracerParams(item, index) {
      return {
        sku_id: item.ssuList[0].sku_id,
        ssu_id: item.ssuList[0].ssuId,
        datatype: this.dataType,
        str_sale_class1_id: this.biId + '',
        sku_pos: index,
        goods_status: item.ssuList[0]?.statusInfo?.status || 0,
        price: item.ssuList[0].priceSpm || ''
      }
    },
    async getHotSaleRankInfo(biId) {
      try {
        this.isLoading = true
        const rankInfo = await API.recommend.hotSaleRankInfo()
        this.biList = rankInfo.biList || ''
        if (!biId) {
          this.biId = this.biList[0].biId
        }
        this.cityName = rankInfo.cityName || ''
        this.labelName = rankInfo.labelName || ''
        this.headImg = rankInfo.img || headBgImg
        await this.getHotGoodList(this.biId)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },
    async getHotGoodList(biId) {
      let res
      try {
        this.isLoading = true
        this.isEmpty = false
        res = await API.recommend.getGoodsInfoStream({
          class1Id: biId,
          moduleKey: 470,
          size: 15
        })
        if (res.rows.length) {
          this.goodsList = res.rows.map((item, index) => {
            item.ssuList[0].traceType = 'addCart'
            item.ssuList[0].traceType2 = 'gotoInfo'
            item.ssuList[0].traceInfo = {
              ssu_id: item.ssuList[0].ssuId || '',
              sku_id: item.skuBase.skuId || '',
              sku_pos: index,
              str_sale_class1_id: this.biId + '',
              datatype: this.dataType
            }
            item.ssuInfo = item.ssuList[0]
            return item
          })
          this.isEmpty = false
        } else {
          this.goodsList = []
          this.isEmpty = true
        }
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
        this.isEmpty = true
      }
    },
    handleChangeTab(biId) {
      this.biId = biId
      this.getHotGoodList(biId)
      this.onClickTabTrack()
    },
    // 点击分类埋点
    onClickTabTrack() {
      this.$track(this.$trackMap.hotSaleList.clickTab, {
        str_sale_class1_id: this.biId + '',
        datatype: this.dataType
      })
    },
    // 悬浮购物车点击
    onClickFloatCartTrack() {
      this.$track(this.$trackMap.hotSaleList.clickFloatCart, {
        datatype: this.dataType
      })
    },
    // 其他榜单页点击
    onClickMoreListTrack() {
      this.$track(this.$trackMap.hotSaleList.clickMoreList, {
        datatype: this.dataType
      })
    },
    // 跳转详情埋点
    onGotoDetailTrack(item, index) {
      this.$track(this.$trackMap.hotSaleList.gotoInfo, {
        sku_id: item.ssuList[0].sku_id,
        ssu_id: item.ssuList[0].ssuId,
        str_sale_class1_id: this.biId + '',
        sku_pos: index,
        datatype: this.dataType
      })
    },
    // 进店的埋点
    onGotoShopTrack(item, index) {
      this.$track(this.$trackMap.hotSaleList.gotoShop, {
        sku_id: item.ssuList[0].sku_id,
        ssu_id: item.ssuList[0].ssuId,
        pop_id: item.popInfo?.popId || 0,
        sku_pos: index,
        datatype: this.dataType
      })
    },
    goBack() {
      this.$track(this.$trackMap.hotSaleList.goBack, {
        datatype: this.dataType
      })
      this.$back()
    },
    onAddGoodsTrack(item, index) {
      this.$track(this.$trackMap.hotSaleList.addCart, {
        sku_id: item.ssuList[0].sku_id,
        ssu_id: item.ssuList[0].ssuId,
        str_sale_class1_id: this.biId + '',
        sku_pos: index,
        datatype: this.dataType
      })
    },
    handlePageTrack() {
      // 禁用自动巡航，需手动埋点
      tracerVuePlugin.page('#/hotSaleList', {
        datatype: this.dataType,
        spm: resolveUrlParams().spm || resolveUrlParams().tickReferId || ''
      })
    },
    handleScroll() {
      window.addEventListener('scroll', e => {
        const boundingTop = this.$refs.expandHeader.getBoundingClientRect().top
        if (boundingTop < -60) this.opacity = 1
        if (boundingTop >= 0) this.opacity = 0
        if (boundingTop > -60 && boundingTop < 0)
          this.opacity = Math.abs(boundingTop) / 60
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.hot-sale-header {
  position: relative;

  height: 3.6rem;

  color: #fff;
  background-size: 100% 100%;

  .header-content {
    position: absolute;
    top: 1.2rem;

    width: 100vw;

    font-size: 0;

    @include flex-row-center;
    .position-icon {
      width: 15px;
      height: 17px;
    }
    .city-name {
      margin: 0 9px;
    }
    .city-name,
    .label-name {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
  }
}
.expand-tab {
  position: sticky;
  left: 0;
  z-index: 9;

  border-bottom: 1px solid #f5f5f5;

  line-height: 20px;
  &::before {
    position: absolute;
    top: -0.12rem;
    left: 0;

    width: 100%;
    height: 0.18rem;

    background-color: #fff;

    content: '';
    border-top-right-radius: 0.2rem;
    border-top-left-radius: 0.2rem;
  }
}
.expand-content-empty {
  padding-top: 1.2rem;

  text-align: center;
  img {
    width: 2.4rem;
    height: 2.4rem;
  }
  div {
    margin-top: 0.48rem;
    margin-bottom: 1.68rem;

    font-size: 0.28rem;
    color: #999999;
  }
}
.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
.loading {
  display: flex;

  margin: 110px 0;

  justify-content: center;
}
</style>
